

export enum  ActionsTypes{
    SET_TIME_RANGE = "SET_TIME_RANGE",
    SET_COMPARISON_DATE = "SET_COMPARISON_DATE",
    SET_IS_LOADING = "SET_IS_LOADING"
}